import { render, staticRenderFns } from "./relatedDetailDialog.vue?vue&type=template&id=720d80f8"
import script from "./relatedDetailDialog.vue?vue&type=script&lang=js"
export * from "./relatedDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports